import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { LoadingSpinner } from '@jove-frontend/uikit';

interface IWidgetProps {
  isOpen: boolean;
  theme?: 'default' | 'studiospace' | 'wamo';
  referrer?: string;
  quoteSrc?: string;
  coverNames?: string[];
}

export default function WidgetEmbed({ isOpen, theme = 'default', referrer, quoteSrc }: IWidgetProps) {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [isLoading, setLoading] = useState(true);
  const router = useRouter();
  const { ref } = router.query;

  const token = router.query['token'] as string;
  const refValue = referrer || ref || 'jove-website';

  const src = quoteSrc ?? `${process.env.NX_QUOTE_ENDPOINT}/?${theme ? `ref=${theme}&theme=${theme}` : ''}${refValue ? `&ref=${refValue}` : ''}`;

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return undefined;

    const listener = () => console.log('event listener');

    iframe.addEventListener('load', listener);

    return () => {
      iframe.removeEventListener('load', listener);
    };
  });

  return (
    <>
      {isOpen && isLoading && (
        <div className="fixed inset-0 z-50 mx-auto max-w-[414px] bg-white">
          <div className="flex h-full items-center justify-center">
            {/* <div className="border-brand-primary h-32 w-32 animate-spin rounded-full border-t-2 border-b-2"></div> */}
            <LoadingSpinner />
          </div>
        </div>
      )}
      {isOpen && (
        <iframe
          ref={iframeRef}
          id="widgetIframe"
          title="Jove Insurance Quote"
          allowFullScreen={true}
          allow="payment"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation allow-downloads"
          className="scrolling-touch margin-0 padding-0 fixed inset-0 z-50 h-full w-full overflow-y-scroll border-0"
          src={src}
          onLoad={() => setLoading(false)}
        />
      )}
    </>
  );
}
